import script from "./LoginBody.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginBody.vue?vue&type=script&setup=true&lang=js"

import "./LoginBody.vue?vue&type=style&index=0&id=05c80918&scoped=true&lang=css"

import exportComponent from "/Users/ronnasat/S3/trueeye_backend_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c80918"]])

export default __exports__